// removed by extract-text-webpack-plugin
module.exports = {"Skill_IMG":"skill__Skill_IMG__2zJSu","Skill_Main":"skill__Skill_Main__47qB1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skill/skill.css
// module id = 70
// module chunks = 0